import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './Button';

interface BackButtonProps {
    className?: string;
    label?: string;
    to?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ className = '', label = 'Back', to }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <Button
            variant="ghost"
            onClick={handleBack}
            className={`text-white/40 hover:text-white hover:bg-white/5 rounded-xl group ${className}`}
        >
            <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" />
            {label}
        </Button>
    );
};
